import React from 'react';
import PropTypes from 'prop-types';

const withComma = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const Case = (props) => {
  return (
    <div className="case">
      <div className={`number ${props.color}`}>
        {withComma(props.number)}
      </div>
      <div className="title">{props.title}</div>
    </div>
  );
};

export default Case;

Case.propTypes = {
  title: PropTypes.string,
  number: PropTypes.number,
  color: PropTypes.string,
};

Case.defaultProps = {
  number: 0,
  title: "",
  color: "",
};



// WEBPACK FOOTER //
// ./src/pages/HomePage/components/Case.js